export const FETCH_YEAR_INFO = 'yearinfo/FETCH_YEAR_INFO';
export const FETCH_YEAR_INFO_SUCCESS = 'yearinfo/FETCH_YEAR_INFO_SUCCESS';